
import Vue from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth/getters"
import { getV4Host } from "~/scripts/useful-functions"

export default Vue.extend({
  name: "TheFooterES",
  extends: FooterBase,
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    }),
    v4Host(): string {
      return getV4Host(this.$config.v4Host, "es")
    }
  }
})
